export const PRODUCT_HEIGHT_EXTENDER_CAP = {
  label: 'Chimney Extender Cap',
  value: 'PRODUCT_HEIGHT_EXTENDER_CAP'
};
